import React from 'react';
import { SpacingName, Typography } from '@doveit/lego';
import { BasicSectionProps, SoldPropertyPreview } from '../types';
import PageSection from '../../components/page-section/PageSection';
import Markdown from '../../components/markdown/Markdown';
import ArticleMarkdown from '../../components/article-markdown/ArticleMarkdown';
import CardsHList from '../../components/cards-hlist/CardsHList';
import SoldPropertyCard from '../../components/sold-property-card/SoldPropertyCard';

export interface SoldPropertiesSectionProps extends BasicSectionProps {
  properties: SoldPropertyPreview[],
}

export const SoldPropertiesSection: React.FC<SoldPropertiesSectionProps> = ({
  title,
  content,
  properties,
}) => {
  const hasHeader = !!(title || content);

  return (
    <PageSection>
      {hasHeader && (
        <PageSection.Wrapper>
          <PageSection.Title>
            <Markdown>
              {title.trim()}
            </Markdown>
          </PageSection.Title>
          {content && (
            <PageSection.Block>
              <Typography.BODY>
                <ArticleMarkdown>
                  {content.trim()}
                </ArticleMarkdown>
              </Typography.BODY>
            </PageSection.Block>
          )}
        </PageSection.Wrapper>
      )}
      <PageSection.Wrapper withoutPad>
        <PageSection.Block noSpacing={!hasHeader}>
          <CardsHList
            inline={3}
            sideSpacing={SpacingName.SMALL}
          >
            {properties.map((property) => (
              <CardsHList.Item key={property.id}>
                <SoldPropertyCard
                  title={property.title}
                  saving={property.savingLabel}
                  image={property.image.url}
                  // @TODO Aggiornare SoldPropertyPreview in modo che accetti l'alt image
                  banner="Venduto"
                />
              </CardsHList.Item>
            ))}
          </CardsHList>
        </PageSection.Block>
      </PageSection.Wrapper>
    </PageSection>
  );
};

export default SoldPropertiesSection;
